import { folderSharing } from '@edulastic/constants'

const { FOLDER_PERMISSION, FOLDER_SHARE_TYPE } = folderSharing

const getShareType = (row) =>
  row?.shareType || row?.sharedType || FOLDER_SHARE_TYPE.USER

export const initPendingFromFolder = (folder) => {
  const sharedWith = folder?.sharedWith || []
  const ownerId = folder?.owner?._id

  const users = sharedWith
    .filter((row) => getShareType(row) === FOLDER_SHARE_TYPE.USER)
    .filter((row) => row._id && String(row._id) !== String(ownerId))
    .map((row) => ({
      _id: row._id,
      name: row.name,
      email: row.email,
      permission:
        row.permission === FOLDER_PERMISSION.EDITOR
          ? FOLDER_PERMISSION.EDITOR
          : FOLDER_PERMISSION.VIEWER,
    }))

  const districtViewer = sharedWith.some(
    (row) => getShareType(row) === FOLDER_SHARE_TYPE.DISTRICT
  )

  return { users, districtViewer }
}

export const buildSharePayload = (pendingUsers, districtViewer) => ({
  users: pendingUsers.map(({ _id, permission }) => ({ _id, permission })),
  districtViewer: !!districtViewer,
})

export const isPendingUserChanged = (user, originalUsers) => {
  const original = originalUsers.find((u) => String(u._id) === String(user._id))
  if (!original) return true
  return original.permission !== user.permission
}

export const isNewPendingUser = (user, originalUsers) =>
  !originalUsers.some((u) => String(u._id) === String(user._id))

export const getUserDisplayName = (user) => {
  const source = user?._source || user || {}
  return (
    [source.firstName, source.lastName].filter(Boolean).join(' ').trim() ||
    user?.name ||
    ''
  )
}

export const getUserEmail = (user) => {
  const source = user?._source || user || {}
  return source.email || user?.email || ''
}

export const formatUserLabel = (user) => {
  const name = getUserDisplayName(user)
  const email = getUserEmail(user)
  if (name && email) return `${name} (${email})`
  return name || email || ''
}

export const hasFolderShareChanges = ({
  pendingUsers,
  originalUsers,
  districtViewer,
  originalDistrictViewer,
  selectedUsers,
}) => {
  if (!!districtViewer !== !!originalDistrictViewer) return true
  if ((selectedUsers || []).length > 0) return true
  if ((pendingUsers || []).length !== (originalUsers || []).length) return true
  return (pendingUsers || []).some(
    (user) =>
      isNewPendingUser(user, originalUsers) ||
      isPendingUserChanged(user, originalUsers)
  )
}

export const FOLDER_ADD_DISCLAIMER =
  'Please note this will not impact access to tests inside the folder; only users the test(s) are directly shared with can access them.'

export const FOLDER_REMOVE_DISCLAIMER =
  'Please note this will not impact access to tests inside the folder; anyone the test(s) are directly shared with can still access them.'

export const VIEWER_FOLDER_TOOLTIP =
  'You only have viewer access to this folder.'

export const GIVE_ACCESS_MODE = {
  DISTRICT: 'DISTRICT',
  INDIVIDUALS: 'INDIVIDUALS',
}

export const getDistrictViewerForShare = ({
  giveAccessMode,
  districtInAccessList,
  districtRemovedFromAccess,
}) => {
  if (districtRemovedFromAccess) {
    return false
  }
  if (giveAccessMode === GIVE_ACCESS_MODE.DISTRICT) {
    return true
  }
  return !!districtInAccessList
}

export const shouldShowDistrictInAccessList = ({
  districtInAccessList,
  districtRemovedFromAccess,
}) => !!districtInAccessList && !districtRemovedFromAccess
